module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "tit",
    attrs: {
      "id": "map"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/map.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "page-break"
  }, [_c('p', {
    staticClass: "sp"
  }), _vm._v(" "), _c('p', {
    staticClass: "FMH1"
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("THE ISKYRNE")])]), _vm._v(" "), _c('p', {
    staticClass: "MAP"
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("1.")]), _vm._v(" H"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("ERGILSBERG")])]), _vm._v(" "), _c('p', {
    staticClass: "MAP"
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("2.")]), _vm._v(" M"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("ONASTERY AT ")]), _vm._v("H"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("ERGILSBERG")])]), _vm._v(" "), _c('p', {
    staticClass: "MAP"
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("3.")]), _vm._v(" S"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("IGLUFJORDHUR")])]), _vm._v(" "), _c('p', {
    staticClass: "MAP"
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("4.")]), _vm._v(" F"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("REYASHEALL")])]), _vm._v(" "), _c('p', {
    staticClass: "MAP"
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("5.")]), _vm._v(" O"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("THINNSAESC")])]), _vm._v(" "), _c('p', {
    staticClass: "MAP"
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("6.")]), _vm._v(" N"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("ITHOGSFJOLL")])]), _vm._v(" "), _c('p', {
    staticClass: "MAP"
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("7.")]), _vm._v(" F"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("RANANGFORD & ")]), _vm._v("A"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("ETTRYNHEIM")])]), _vm._v(" "), _c('p', {
    staticClass: "MAP"
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("8.")]), _vm._v(" B"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("RAVOLL")])]), _vm._v(" "), _c('p', {
    staticClass: "MAP"
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("9.")]), _vm._v(" T"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("HORSBAER")])]), _vm._v(" "), _c('p', {
    staticClass: "MAP"
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("10.")]), _vm._v(" V"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("ESTFJORTHR")])]), _vm._v(" "), _c('p', {
    staticClass: "MAP"
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("11.")]), _vm._v(" A"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("RAKENSBERG")])]), _vm._v(" "), _c('p', {
    staticClass: "MAP"
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("12.")]), _vm._v(" B"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("EORNESBEORG")])]), _vm._v(" "), _c('p', {
    staticClass: "MAP"
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("13.")]), _vm._v(" B"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("EONVITHR")])]), _vm._v(" "), _c('p', {
    staticClass: "MAP"
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("14.")]), _vm._v(" K"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("ERLAUGSTROND")])]), _vm._v(" "), _c('p', {
    staticClass: "MAP"
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("15.")]), _vm._v(" K"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("ETILLHILL")])]), _vm._v(" "), _c('p', {
    staticClass: "MAP"
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("16.")]), _vm._v(" N"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("EW ")]), _vm._v("N"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("IDAVELLIR")])]), _vm._v(" "), _c('p', {
    staticClass: "MAP"
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("17.")]), _vm._v(" N"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("ORTH ")]), _vm._v("P"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("OLE")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-267a28ee","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/map.vue
// module id = 72
// module chunks = 0